"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _wedding = require("@/api/wedding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MarketingEvents',
  data: function data() {
    return {
      picObj: {
        'TB': require('@/assets/platformIcon/tb.png'),
        'JD': require('@/assets/platformIcon/jd.png'),
        'PDD': require('@/assets/platformIcon/pdd.png'),
        'WPH': require('@/assets/platformIcon/wph.png')
      },
      options: [],
      queryData: {
        orderNo: '',
        title: '',
        goodsId: '',
        memberId: '',
        platformCode: '',
        activityId: '',
        orderStatus: '',
        timeRange: [],
        payTimeStart: '',
        payTimeEnd: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0,
      // 条数
      platformMapping: {
        'TB': '淘宝',
        'JD': '京东',
        'PDD': '拼多多',
        'WPH': '唯品会',
        'DY': '抖音'
      }
    };
  },
  created: function created() {
    this.productAll();
    this.orderList();
  },
  methods: {
    copy: function copy(val) {
      var _this = this;
      this.$copyText(val).then(function () {
        _this.$notify.success({
          title: '温馨提示',
          message: '拷贝成功'
        });
      }).catch(function () {
        _this.$notify.success({
          title: '温馨提示',
          message: '拷贝失败，请手动复制'
        });
      });
    },
    productAll: function () {
      var _productAll = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _wedding.get_select)(params);
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function productAll() {
        return _productAll.apply(this, arguments);
      }
      return productAll;
    }(),
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.orderList();
    },
    onTimeChange: function onTimeChange(val) {
      if (val && val.length === 2) {
        this.queryData.payTimeStart = val[0];
        this.queryData.payTimeEnd = val[1];
      } else {
        this.queryData.payTimeStart = '';
        this.queryData.payTimeEnd = '';
      }
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        orderNo: '',
        title: '',
        goodsId: '',
        memberId: '',
        platformCode: '',
        activityId: '',
        orderStatus: '',
        timeRange: [],
        payTimeStart: '',
        payTimeEnd: '',
        page: 1,
        size: 10
      };
      this.orderList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.orderList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.orderList();
    },
    orderList: function () {
      var _orderList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData); // timeRange 仅用于日期选择器展示，提交参数时剔除
              delete params.timeRange;
              _context2.n = 1;
              return (0, _wedding.get_order)(params);
            case 1:
              res = _context2.v;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function orderList() {
        return _orderList.apply(this, arguments);
      }
      return orderList;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.memberName
        }
      });
    },
    // 订单详情
    onOrderDetails: function onOrderDetails(value) {
      this.$router.push({
        path: '/orderManagement/orderDetails',
        query: {
          orderNo: value.orderNo,
          unionCode: value.platformCode
        }
      });
    },
    // 商品跳转
    onGoodsJump: function onGoodsJump(value) {
      if (value.goodsUrl) {
        window.open(value.goodsUrl, '_blank');
      }
    },
    // 导出
    onExport: function () {
      var _onExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.queryData); // timeRange 仅用于日期选择器展示，剔除分页与展示字段
              delete params.timeRange;
              delete params.page;
              delete params.size;
              _context3.n = 1;
              return (0, _wedding.export_order)({
                moduleId: 4,
                exportType: 1,
                querySnapshot: params
              });
            case 1:
              res = _context3.v;
              if (res.data && res.data.downloadUrl) {
                window.open(res.data.downloadUrl, '_blank');
              } else {
                this.$message.warning('导出失败，请稍后重试');
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onExport() {
        return _onExport.apply(this, arguments);
      }
      return onExport;
    }()
  }
};